var render = function render(){var _vm=this,_c=_vm._self._c;return _c('area-select',{attrs:{"size":"small","type":"code","level":2,"value":_vm.selected,"icon":"direction-right-icon","data":_vm.pcaa},on:{"change":_vm.areaChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }